import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { ProductType, ProductTypeDetails } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ProductTypeService extends TmsWebBaseEditService<ProductType, ProductTypeDetails> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('ProductType', $localize`Product Type`, httpService, notificationService);
  }

  getProcessType(): Observable<ProductType> {
    return this.httpService.get<ProductType>(`${this.apiUrl}/GetProcessType`);
  }
}
